import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { StationsState } from '../../types';

import { getStations } from '../operations/getStations';
import { getSortedRoadsideServices } from 'entities/roadsideServices/utils/getSortedRoadsideServices';

import { STATUS_LOADING } from 'common/constants';
import { EMPTY_ARRAY } from 'shared/constants';

export const setStations = (builder: ActionReducerMapBuilder<StationsState>) => builder
  .addCase(getStations.pending, (state) => {
    state.stations.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getStations.fulfilled, (state, { payload = EMPTY_ARRAY }) => {
    state.stations.loadingStatus = STATUS_LOADING.done;
    state.stations.data = payload.map(item => ({
      ...item,
      roadsideServiceCodes: getSortedRoadsideServices([...item.roadsideServiceCodes])
    }));
  })
  .addCase(getStations.rejected, (state) => {
    state.stations.loadingStatus = STATUS_LOADING.error;
  });
